<div class="faq-container">
  <div class="faq-header">
    <h1>Domande Frequenti</h1>
    <p class="subtitle">Tutto quello che devi sapere su PMO2</p>
  </div>

  <div class="faq-content">
    <p-accordion [multiple]="true">
      <p-accordionTab *ngFor="let section of faqSections" [header]="section.title">
        <div class="faq-section">
          <div *ngFor="let item of section.items" class="faq-item">
            <div class="question">
              <i class="pi pi-question-circle"></i>
              <span>{{ item.question }}</span>
            </div>
            <div class="answer">
              <i class="pi pi-info-circle"></i>
              <span [innerHTML]="item.answer"></span>
            </div>
            <p-divider *ngIf="!item.isLast"></p-divider>
          </div>
          <div *ngIf="section.title === 'Supporto'" class="support-section">
            <p-divider></p-divider>
            <div class="support-content">
              <p>Non hai trovato la risposta che cercavi?</p>
              <button pButton pRipple label="Contatta il Supporto" icon="pi pi-envelope" class="p-button-outlined" (click)="openSupportModal()"></button>
            </div>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
</div>

<app-support-modal></app-support-modal>
